import { BasicAuth } from 'types/basic-auth';
import { FetchHandler } from './fetchhandler';

export class VisitorTracker {

    /**
     * Track visitor if it's needed
     */
    static trackVisitor() : void {
        const trackPageData = document.getElementById('trackPageViewData');
        if (!trackPageData || !(trackPageData instanceof HTMLElement)) {
            // no need to throw error
            return;
        }

        const {
            needTracking, url, apiUrl, apiId,
        } = trackPageData.dataset;
        if (needTracking !== '1') {
            // no need to throw error
            return;
        }

        if (typeof url === 'undefined' || typeof apiUrl === 'undefined' || typeof apiId === 'undefined') {
            throw new Error('TrackVisitor: Necessary data are missing!');
        }

        VisitorTracker.sendTrackPageView(url);
        VisitorTracker.sendTransactionPageView(apiUrl, apiId);
    }

    /**
     * First request to track the page view
     *
     * @param url
     * @return void
     */
    static sendTrackPageView(url : string) : void {
        FetchHandler.create()
        .setMethod('GET')
        .setXMLHttpRequest()
        .setUrl(VisitorTracker.prepareUrl(url, {
            url: window.location.href,
        }))
        .send()
        .catch((error) => {
            throw error;
        });
    }

    /**
     * Second request to track TPV (Transaction Page View)
     *
     * @param apiUrl
     * @param apiId
     *
     * @return void
     */
    static sendTransactionPageView(apiUrl : string, apiId : string) : void {
        FetchHandler.create()
        .setMethod('GET')
        .setMode('no-cors')
        .setXMLHttpRequest()
        .setUrl(VisitorTracker.prepareUrl(`${apiUrl}/common_ajax/tpv`, {
            muUserId: apiId,
            url: window.location.href,
        }))
        .send()
        .catch((error) => {
            throw error;
        });
    }

    /**
     * Add new paramaters to URL and remove the credentials from it
     * @param url
     * @param paramObject
     * @return {string}
     */
    static prepareUrl(url : string, paramObject : object) : string {
        const params = new URLSearchParams();
        const parameterKeys = Object.keys(paramObject);
        const parameterValues = Object.values(paramObject);
        const urlObj = VisitorTracker.getCredentialsFromUrl(url);
        parameterKeys.map((value : string, index : number) => {
            if (typeof parameterValues[index] !== 'undefined') {
                params.set(value, (parameterValues[index] as string));
            }
            return true;
        });

        // We need to remove the credentials from URL
        if (urlObj !== null) {
            url = url.replace(`${urlObj.username}:${urlObj.password}@`, '');
        }

        return `${url}?${params.toString()}`;
    }

    /**
     * Collects the credentials from the URL
     * @param url
     *
     * @return BasicAuth | null
     */
    static getCredentialsFromUrl(url : string) : BasicAuth | null {
        const urlObj = new URL(url);
        if (typeof urlObj.username !== 'undefined' && typeof urlObj.password !== 'undefined') {
            return {
                username: urlObj.username,
                password: urlObj.password,
            };
        }
        return null;
    }

}
